import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { articleList } from "@/mocks/articles";

export default function NewsSection() {
  const featured = articleList[0];
  const rest = articleList.slice(1, 4);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <SectionHeading
          eyebrow="深度阅读"
          title="资讯与专题"
          desc="漫评盘点、创作干货与行业观察，为你提供有价值的深度内容。"
        />
        <Link
          to="/news"
          className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
        >
          浏览全部资讯
          <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/news/${featured.id}`}
          className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50"
        >
          <div className="relative aspect-[16/8] overflow-hidden">
            <img
              src={featured.cover}
              alt={featured.title}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-4 top-4 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
              {featured.category}
            </span>
          </div>
          <div className="p-6">
            <p className="text-xs text-foreground-500">
              {featured.date} · {featured.readTime} 阅读
            </p>
            <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-700">
              {featured.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
          </div>
        </Link>

        <div className="flex flex-col gap-4">
          {rest.map((a) => (
            <Link
              key={a.id}
              to={`/news/${a.id}`}
              className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
            >
              <img
                src={a.cover}
                alt={a.title}
                className="h-24 w-32 shrink-0 rounded-lg object-cover"
              />
              <div className="min-w-0 flex-1 py-1">
                <span className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                  {a.category}
                </span>
                <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {a.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {a.date} · {a.readTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}